import type { FC, ReactNode } from 'react';

import { LockClosedIcon } from '@heroicons/react/24/solid';

import { GateBannerCard, GateBannerNote } from './GateBannerCard';

interface OwnerMessageCardProps {
  title: string;
  message: string;
  note?: string;
  action?: ReactNode;
}

export const OwnerMessageCard: FC<OwnerMessageCardProps> = ({ title, message, note, action }) => (
  <GateBannerCard>
    <div className="flex size-12 items-center justify-center rounded-full bg-community-text-on-bg/10">
      <LockClosedIcon aria-hidden="true" className="size-5 text-community-text-on-bg/80" />
    </div>
    <h2 className="mt-4 text-xl font-semibold leading-7 tracking-[-0.4px]">{title}</h2>
    <p className="mt-2 max-w-md whitespace-pre-line text-sm leading-5 text-community-text-on-bg/60">{message}</p>
    {note && <GateBannerNote>{note}</GateBannerNote>}
    {action}
  </GateBannerCard>
);
